import TagBase from './TagBase';
import styled from '@emotion/styled';

const AttachedTag = styled(TagBase)(({ theme }) => ({
  marginRight: 8,
  marginBottom: 8,
  padding: '4px 8px',
  maxWidth: 320,
  height: 34,
  display: 'flex',
  alignItems: 'center',
  boxSizing: 'border-box',
  overflow: 'hidden',
  borderRadius: 4,
  span: {
    fontWeight: 500,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '.MuiIconButton-root': {
    transition: theme.transitions.create('all'),
    ':first-of-type': {
      marginLeft: 4,
    },
  },
  ':not(:hover):not(:focus-within) .MuiIconButton-root': {
    marginLeft: 0,
    marginRight: -30,
    opacity: 0,
  },
}));

export default AttachedTag;
